import { useSyncExternalStore } from 'react';

const subscribe = (callback: () => void) => {
  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
  return () => observer.disconnect();
};

const getSnapshot = () =>
  document.documentElement.classList.contains('dark');

export const useDarkMode = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);
